import { useState, useEffect } from 'react'
import { toast } from 'react-toastify'

export const useFetchAllVehiclePayments = ({marvarApi, dispatch, onLogout, Helpers, Forms}) => {
    const {getCurrentDate} = Helpers
    
    const {FormRequestGlobal:{setFormState}} = Forms

    const [vehiclePayments, setVehiclePayments] = useState([])
    const [loadingFetchVehiclePayments, setLoadingFetchVehiclePayments ] = useState(false) //estado para animacion de carga
    
    const [paramsToSearch, setParamsToSearch] = useState({})

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllVehiclePayments = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            if(paramsToSearch.pendiente === true){
                const response = await marvarApi.get(`/vehicle/mgmt-payments/get-deposit-pendientes`)
                return response.data
            }
            const response = await marvarApi.post(`/vehicle/mgmt-payments/${paramsToSearch.idcredito}`, {currentDate:getCurrentDate()})
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcredito > 0 ){
            setLoadingFetchVehiclePayments(true)
            fetchData()
                .then((resp) => {

                    const rows = resp?.data ?? []
                    setVehiclePayments(rows)

                    if (rows.length > 0) {
                        setFormState((prevState) => ({
                            ...prevState,
                            nombre: rows[0].nombre || '',
                            dpi: rows[0].dpi || '',
                            telefono: rows[0].telefono || '',
                            email: rows[0].correo || '',
                            direccion: rows[0].direccion || '',
                        }))
                    } else {
                        setFormState((prevState) => ({
                            ...prevState,
                            idpago: 0,
                            idcredito: 0,
                            nombre: '',
                            dpi: '',
                            telefono: '',
                            email: '',
                            direccion: '',
                        }))
                        toast.warn('Crédito no encontrado', {
                            position: 'top-right',
                            theme: 'colored',
                        })
                    }

                    setLoadingFetchVehiclePayments(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchVehiclePayments(false)
                })
        }

        if(paramsToSearch.pendiente === true ){
            setLoadingFetchVehiclePayments(true)
            fetchData()
                .then((resp) => {

                    const rows = resp?.data ?? []
                    setVehiclePayments(rows)

                    if (rows.length === 0) {
                        toast.warn('No se encontraron pagos pendientes de aprobación', {
                            position: 'top-right',
                            theme: 'colored',
                        })
                    }

                    setLoadingFetchVehiclePayments(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchVehiclePayments(false)
                })
        }
    }, [execute])

    return { vehiclePayments, loadingFetchVehiclePayments, setParamsToSearch, executeFetchAllVehiclePayments, setVehiclePayments }

}

export const useFetchAllVehicleCredits= ({marvarApi, dispatch, onLogout, Forms}) => {
    const {FormRequestGlobal:{setFormState}} = Forms

    const [vehicleCredits, setVehicleCredits] = useState([])
    
    const [paramsToSearch, setParamsToSearch] = useState({})

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllVehicleCredits = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.post(`/vehicle/common/get-vehicle-credits`,{
                campo: paramsToSearch.campo,
                identificador: paramsToSearch.identificador
            })
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.campo !== undefined &&  paramsToSearch.identificador !== undefined ){
            fetchData()
                .then((resp) => {
                    const { rows } = resp
                    alertMessage(resp)
                    setVehicleCredits(rows)
                    setFormState((prevState) => ({
                        ...prevState,
                        idcredito : 0,
                        identificador: ''
                    }))
                }) 
                .catch(e => {
                    console.log(e, '________ERROR')
                })
            }
    }, [execute])

    return { vehicleCredits, setParamsToSearch, executeFetchAllVehicleCredits, setVehicleCredits }
}


export const useFetchAllCashRegisters= ({marvarApi, dispatch, onLogout}) => {
    const [cashRegisters, setCashRegisters] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllCashRegisters = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/caja`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    setCashRegisters(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { cashRegisters, executeFetchAllCashRegisters }
}

export const useFetchAllBanks= ({marvarApi, dispatch, onLogout}) => {
    const [banks, setBanks] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllBanks = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/banco`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp

                    setBanks(data)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { banks, executeFetchAllBanks }
}

export const useFetchAllDeposits= ({marvarApi, dispatch, onLogout, Forms}) => {
    const [deposits, setDeposits] = useState([])
    const [loadingFetchDeposits, seteLoadingFetchDeposits ] = useState(false) //estado para animacion de carga
    
    const {FormRequestGlobal:{formState}} = Forms


    const [ execute, setExecute ] = useState(false)
    const executeFetchAllDeposits = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/mgmt-payments/get-deposit/${formState.idpago}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idpago > 0 ){
            seteLoadingFetchDeposits(true)
            fetchData()
                .then((resp) => {
                    setDeposits(resp.data)
                    seteLoadingFetchDeposits(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    seteLoadingFetchDeposits(false)
                })
        }
    }, [execute])

    return { deposits, loadingFetchDeposits, executeFetchAllDeposits }
}

export const useFetchInfoDeposit = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormDeposit:{setFormState} } = Forms

    // 1. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoDeposit = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-payments/get-deposit-by-ID/${paramsToSearch.idmovimiento}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idmovimiento > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idmovimiento: data.idmovimiento || '',
                        idcaja : data.idcaja || '',
                        idbanco : data.idbanco || '',
                        boleta_numero : data.boleta_numero || '',
                        boleta_foto_path : data.boleta_foto_path || '',
                        boleta_foto_originalname : data.boleta_foto_originalname || '',
                        aprobacion_referencia_ach : data.aprobacion_referencia_ach || '',
                        aprobacion_observaciones : data.aprobacion_observaciones || '',
                        aprobacion_check : data.aprobacion_check || '',
                        aprobacion_check_original : data.aprobacion_check || '',
                        deposito_dolares : data.deposito_dolares || '',
                        deposito_fecha : data.deposito_fecha || '',
                        deposito_moneda : data.deposito_moneda || '',
                        deposito_monto : data.deposito_monto || '',
                        deposito_observaciones : data.deposito_observaciones || '',
                        deposito_quetzales : data.deposito_quetzal || '',
                        deposito_tipo_cambio : data.deposito_tipo_cambio || '',
                        movimiento_tipo : data.movimiento_tipo || ''
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { setParamsToSearch, executeFetchInfoDeposit }
}




const alertMessage = (res, toggle) => {

    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}



